module.exports = __webpack_public_path__ + "img/gd-woman-bottom-left.91452db6.png";